import * as React from 'react'

import ui from '../../../../common/constants/ui'
import EnhancedLazyLoad from '../../../components/enhancedLazyLoad'
import ImagePreview from '../../../components/imagePreview'
import TrendingSash from '../../../components/trendingSash'
import ImagePlaceholder from '../../imagePlaceholder'
import { IItemCard } from '../interface'

const ItemCardSquarePreview = (props: IItemCard) => {
  const { item, rank, onItemLinkClick } = props
  /* tslint:disable */
  return (
    <section>
      {item.trending && (
        <EnhancedLazyLoad height="100%" once offset={ui.lazyLoadOffset}>
          <TrendingSash large />
        </EnhancedLazyLoad>
      )}
      <a href={`${item.url}?s_rank=${rank}`} onClick={onItemLinkClick}>
        <ImagePlaceholder ratio={1}>
          <ImagePreview item={item} />
        </ImagePlaceholder>
      </a>
    </section>
  )
  /* tslint:enable */
}

export default ItemCardSquarePreview
